module.exports = __webpack_public_path__ + "static/media/frontend.76d732ce.avif";